import ModalContainer from "./ModalContainer";
import { Select, Form, Input, message } from "antd";
import { Bank, Provider } from "../TransactionSettings";
import { useEffect, useState } from "react";
import { putData } from "../../../../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../../../../api/ajax-endpoints";
import Loader from "../../../../../../../NewComponents/Loader/Loader.component";
import { useQueryCache } from "react-query";

const { Option } = Select;

interface IEditTransferLimit {
  open: boolean;
  handleCancel: () => void;
  title: string;
  confirmBtnText: any;
  cancelBtnTxt: string;
  easyPayBankList: Bank[];
  selectedProviderDetails: Provider | null;
}

const EditTransferLimit = ({
  open,
  handleCancel,
  title,
  cancelBtnTxt,
  confirmBtnText,
  easyPayBankList,
  selectedProviderDetails,
}: IEditTransferLimit) => {
  const [form] = Form.useForm();
  const [accountId, setAccountId] = useState<number | null>(null);
  const [selectedBankCode, setSelectedBankCode] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const queryCache = useQueryCache();

  useEffect(() => {
    const id = selectedProviderDetails?.accounts?.find(
      (account) => account.bankCode === selectedBankCode,
    )?.id;
    if (id) {
      setAccountId(id);
    }
  }, [selectedBankCode, selectedProviderDetails]);

  const handleOk = () => {
    form.submit();
  };

  const onFinish = async (values: any) => {
    setIsLoading(true);

    try {
      const response = await putData(
        ajaxEndpoints.UPDATE_OUTWARD_TRANSFER_PROVIDER,
        {
          outwardTransferProviderId: selectedProviderDetails?.id,
          outwardTransferProviderAccountId: accountId,
          maximumTransferAmount: values?.maximumTransferAmount,
          thresholdAmount: selectedProviderDetails?.thresholdAmount,
        },
      );

      if (response?.status === 200) {
        await queryCache.invalidateQueries(["fetchOutwardTransferProviders"]);
        message.success(response.data.message);
        form.resetFields();
        handleCancel();
      }
    } catch (error) {
      console.log(error);
      message.error(
        error.message || "Failed to update outwards transfer provider",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalContainer
      open={open}
      handleOk={handleOk}
      handleCancel={handleCancel}
      title={title}
      confirmBtnText={isLoading ? <Loader /> : confirmBtnText}
      cancelBtnTxt={cancelBtnTxt}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item label="Select Account">
          <Select
            className="w-full"
            id="payment_provider"
            size="large"
            onChange={(value) => setSelectedBankCode(value)}
          >
            {easyPayBankList?.map((bank: Bank) => (
              <Option value={bank.bankCode}>{bank.bankName}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          htmlFor="minimum_transfer_amount"
          label="Set minimum transfer"
          name="minimumTransferAmount"
        >
          <Input
            className="w-full"
            id="minimum_transfer_amount"
            size="large"
            type="number"
          />
        </Form.Item>
        <Form.Item
          htmlFor="maximum_transfer_amount"
          label="Set maximum transfer"
          name="maximumTransferAmount"
        >
          <Input
            className="w-full"
            id="maximum_transfer_amount"
            size="large"
            type="number"
          />
        </Form.Item>
      </Form>
    </ModalContainer>
  );
};

export default EditTransferLimit;
